export default __webpack_public_path__ + "static/FAQ_iMCE (EV)-ee0baf40639b06f7a957cb1b0f114d4e.pdf";